var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.527 36.5866C25.7881 35.6272 25.2148 34.6248 24.2554 34.3637L18.1558 32.7033C17.3461 32.5959 16.611 32.792 15.9631 33.2888L13.5562 35.1317L15.2957 41.6227C16.5056 40.4572 17.5804 40.2249 18.754 40.4941L22.2479 41.2951C23.0435 41.4777 23.7914 41.4072 24.4984 40.999L33.2352 35.9549C34.0147 35.505 34.2845 34.4986 33.834 33.7191C33.3842 32.9397 32.3778 32.6698 31.5983 33.1203L25.5135 36.633C25.5182 36.6175 25.5229 36.6021 25.527 36.5866Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3046 37.8585C24.2653 38.1204 25.2657 37.5477 25.5269 36.5869C25.5356 36.5554 25.543 36.5245 25.5497 36.4929C25.1113 37.0374 24.3754 37.304 23.6611 37.1093L20.4028 36.2223C20.186 36.1633 19.9611 36.2922 19.902 36.509C19.8429 36.7252 19.9725 36.9515 20.1887 37.0099L23.3046 37.8585Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.616 34.0624L15.7201 41.915C15.7711 42.1063 15.657 42.3051 15.465 42.3561L14.0134 42.7448C13.8221 42.7958 13.6234 42.6817 13.5717 42.4897L11.4682 34.6378C11.4172 34.4465 11.5313 34.2477 11.7233 34.196L13.1749 33.8073C13.3662 33.7556 13.565 33.8704 13.616 34.0624Z",
    fill: "#4294FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1069 18.7404C37.2564 24.1451 38.8308 26.8474 38.8308 26.8474C39.8218 24.9561 40.4489 23.5442 42.6658 23.1635C42.8222 19.0002 42.9001 16.9189 42.9001 16.9189C37.0382 18.1335 34.1069 18.7404 34.1069 18.7404Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.067 17.4632V28.1631C39.067 28.8076 38.5413 29.3333 37.8968 29.3333H15.4456C14.8011 29.3333 14.2754 28.8076 14.2754 28.1631V17.4632C14.2754 16.8187 14.8011 16.293 15.4456 16.293H37.8975C38.5413 16.293 39.067 16.8187 39.067 17.4632Z",
    fill: "#22C269"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6934 29.3331H15.4456C14.8011 29.3331 14.2754 28.8074 14.2754 28.1628V25.915C16.1633 25.915 17.6934 27.4458 17.6934 29.3331Z",
    fill: "#1CB15F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.067 25.915V28.1628C39.067 28.8074 38.5413 29.3331 37.8967 29.3331H35.6489C35.6489 27.4458 37.179 25.915 39.067 25.915Z",
    fill: "#1CB15F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.067 17.4632V19.711C37.179 19.711 35.6489 18.1809 35.6489 16.293H37.8967C38.5413 16.293 39.067 16.8187 39.067 17.4632Z",
    fill: "#1CB15F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2754 19.711V17.4632C14.2754 16.8187 14.8011 16.293 15.4456 16.293H17.6934C17.6934 18.1809 16.1633 19.711 14.2754 19.711Z",
    fill: "#1CB15F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7521 27.0701C29.1 27.0255 30.9672 25.086 30.9226 22.7381C30.878 20.3902 28.9385 18.5231 26.5906 18.5677C24.2427 18.6123 22.3755 20.5518 22.4201 22.8997C22.4647 25.2475 24.4042 27.1147 26.7521 27.0701Z",
    fill: "#EFF4F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0667 17.4632V20.7946C38.1146 20.9182 37.2177 20.9786 36.2724 20.706C35.2962 20.424 34.4751 19.8399 33.7594 19.141C32.8053 19.6835 31.8466 20.2186 30.8986 20.7711C29.5061 21.5822 27.7035 21.1068 26.8924 19.7144C26.2418 18.5978 26.4204 17.2148 27.2355 16.293H37.8964C38.541 16.293 39.0667 16.8187 39.0667 17.4632Z",
    fill: "#1CB15F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6709 18.5615C28.3561 18.5615 29.8123 19.5424 30.5005 20.9644C29.1799 21.4854 27.6283 20.9765 26.8931 19.7143C26.6816 19.3511 26.5574 18.9597 26.5151 18.5649C26.5662 18.5629 26.6185 18.5615 26.6709 18.5615Z",
    fill: "#E9E8E6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8359 19.6113C27.0756 19.665 27.2542 19.8792 27.2542 20.135V20.2075C27.1193 20.0591 26.9977 19.8947 26.8923 19.7141C26.8729 19.6798 26.8541 19.6456 26.8359 19.6113ZM27.3657 20.3237C27.4402 20.3485 27.512 20.3794 27.5818 20.415C27.7906 20.5224 27.9713 20.6735 28.1102 20.8547C27.839 20.7191 27.5872 20.5412 27.3657 20.3237Z",
    fill: "#1CB15F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3099 16.0215L43.3676 18.2801L39.0667 19.7115C37.2701 19.9545 35.9092 20.0096 33.9595 17.7893C32.9289 18.3841 31.2807 19.3059 30.3582 19.8437C29.4766 20.3573 28.3346 20.0566 27.821 19.1743C27.3081 18.2942 27.6095 17.1501 28.4904 16.6372C30.3562 15.5502 32.0494 14.5183 33.9541 13.5018C34.6926 13.1077 35.4956 13.2077 36.2798 13.4998C38.6135 14.3679 39.4387 15.945 43.3099 16.0215Z",
    fill: "#BBBBBB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0464 14.9742V24.2703C42.0464 24.5059 42.2391 24.6986 42.4747 24.6986H44.2613C44.4969 24.6986 44.6896 24.5059 44.6896 24.2703V14.9742C44.6896 14.7386 44.4969 14.5459 44.2613 14.5459H42.4747C42.2391 14.5459 42.0464 14.7386 42.0464 14.9742Z",
    fill: "#4294FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans2);
export default __webpack_public_path__ + "static/media/trans2.59f2db04144e93e2fd39bca9cf183f31.svg";
export { ForwardRef as ReactComponent };